
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire49a6"];
var parcelRegister = parcelRequire.register;
parcelRegister("4X0pd", function(module, exports) {
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/ 
module.exports = (parcelRequire("ra6e2"));

});
parcelRegister("ra6e2", function(module, exports) {
"use strict";

var $l4FIw = parcelRequire("l4FIw");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $051a5b438cde5927$var$Heading;

var $051a5b438cde5927$var$_extends2 = $l4FIw((parcelRequire("5WrMC")));

var $051a5b438cde5927$var$_objectWithoutProperties2 = $l4FIw((parcelRequire("ib1Q9")));

var $051a5b438cde5927$var$_classnames = $l4FIw((parcelRequire("g3elz")));

var $051a5b438cde5927$var$_filterDOMProps = $l4FIw((parcelRequire("8ktw3")));

var $051a5b438cde5927$var$_propTypes = $l4FIw((parcelRequire("h4kRK")));

var $051a5b438cde5927$var$_react = $l4FIw((parcelRequire("7eprg")));
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/ var $051a5b438cde5927$var$VARIANTS = {
    1: "display",
    2: "pageTitle",
    3: "subtitle1",
    4: "subtitle2",
    5: "subtitle3",
    6: "subtitle3"
};
var $051a5b438cde5927$var$ELEMENTS = {
    "display": "h1",
    "pageTitle": "h2",
    "subtitle1": "h2",
    "subtitle2": "h3",
    "subtitle3": "h4"
};
function $051a5b438cde5927$var$Heading(_ref) {
    var variant = _ref.variant, _ref$size = _ref.size, size = _ref$size === void 0 ? 1 : _ref$size, children = _ref.children, className = _ref.className, otherProps = (0, $051a5b438cde5927$var$_objectWithoutProperties2["default"])(_ref, [
        "variant",
        "size",
        "children",
        "className"
    ]);
    variant = variant || $051a5b438cde5927$var$VARIANTS[size] || "display";
    var Element = $051a5b438cde5927$var$ELEMENTS[variant];
    return $051a5b438cde5927$var$_react["default"].createElement(Element, (0, $051a5b438cde5927$var$_extends2["default"])({
        className: (0, $051a5b438cde5927$var$_classnames["default"])("spectrum-Heading", "spectrum-Heading--".concat(variant), className)
    }, (0, $051a5b438cde5927$var$_filterDOMProps["default"])(otherProps)), children);
}
$051a5b438cde5927$var$Heading.displayName = "Heading";
$051a5b438cde5927$var$Heading.propTypes = {
    /**
   * Variant of the heading to display. This maps to different heading HTML elements:
   * - display: h1
   * - pageTitle: h2
   * - subtitle1: h2
   * - subtitle2: h3
   * - subtitle3: h4
   */ variant: $051a5b438cde5927$var$_propTypes["default"].oneOf([
        "display",
        "pageTitle",
        "subtitle1",
        "subtitle2",
        "subtitle3"
    ]),
    /**
   * Custom classname to apply to the heading.
   */ className: $051a5b438cde5927$var$_propTypes["default"].string
};

});
parcelRegister("l4FIw", function(module, exports) {
function $f57a54d42741b8b9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $f57a54d42741b8b9$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8ktw3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $6107163ca676c195$var$filterReactDomProps;
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/ var $6107163ca676c195$var$DOMProps = {
    "abbr": 1,
    "accept": 1,
    "acceptCharset": 1,
    "accessKey": 1,
    "action": 1,
    "allowFullScreen": 1,
    "allowTransparency": 1,
    "alt": 1,
    "async": 1,
    "autoCapitalize": 1,
    "autoComplete": 1,
    "autoCorrect": 1,
    "autoFocus": 1,
    "autoPlay": 1,
    "cellPadding": 1,
    "cellSpacing": 1,
    "challenge": 1,
    "charset": 1,
    "checked": 1,
    "cite": 1,
    "class": 1,
    "className": 1,
    "cols": 1,
    "colSpan": 1,
    "command": 1,
    "content": 1,
    "contentEditable": 1,
    "contextMenu": 1,
    "controls": 1,
    "coords": 1,
    "crossOrigin": 1,
    "data": 1,
    "dateTime": 1,
    "default": 1,
    "defer": 1,
    "dir": 1,
    "disabled": 1,
    "download": 1,
    "draggable": 1,
    "dropzone": 1,
    "encType": 1,
    "for": 1,
    "form": 1,
    "formAction": 1,
    "formEncType": 1,
    "formMethod": 1,
    "formNoValidate": 1,
    "formTarget": 1,
    "frameBorder": 1,
    "headers": 1,
    "height": 1,
    "hidden": 1,
    "high": 1,
    "href": 1,
    "hrefLang": 1,
    "htmlFor": 1,
    "httpEquiv": 1,
    "icon": 1,
    "id": 1,
    "inputMode": 1,
    "isMap": 1,
    "itemId": 1,
    "itemProp": 1,
    "itemRef": 1,
    "itemScope": 1,
    "itemType": 1,
    "kind": 1,
    "label": 1,
    "lang": 1,
    "list": 1,
    "loop": 1,
    "manifest": 1,
    "max": 1,
    "maxLength": 1,
    "media": 1,
    "mediaGroup": 1,
    "method": 1,
    "min": 1,
    "minLength": 1,
    "multiple": 1,
    "muted": 1,
    "name": 1,
    "noValidate": 1,
    "open": 1,
    "optimum": 1,
    "pattern": 1,
    "ping": 1,
    "placeholder": 1,
    "poster": 1,
    "preload": 1,
    "radioGroup": 1,
    "readOnly": 1,
    "rel": 1,
    "required": 1,
    "role": 1,
    "rows": 1,
    "rowSpan": 1,
    "sandbox": 1,
    "scope": 1,
    "scoped": 1,
    "scrolling": 1,
    "seamless": 1,
    "selected": 1,
    "shape": 1,
    "size": 1,
    "sizes": 1,
    "sortable": 1,
    "span": 1,
    "spellCheck": 1,
    "src": 1,
    "srcDoc": 1,
    "srcSet": 1,
    "start": 1,
    "step": 1,
    "style": 1,
    "tabIndex": 1,
    "target": 1,
    "title": 1,
    "translate": 1,
    "type": 1,
    "typeMustMatch": 1,
    "useMap": 1,
    "value": 1,
    "width": 1,
    "wmode": 1,
    "wrap": 1,
    "onCopy": 1,
    "onCut": 1,
    "onPaste": 1,
    "onLoad": 1,
    "onError": 1,
    "onWheel": 1,
    "onScroll": 1,
    "onCompositionEnd": 1,
    "onCompositionStart": 1,
    "onCompositionUpdate": 1,
    "onKeyDown": 1,
    "onKeyPress": 1,
    "onKeyUp": 1,
    "onFocus": 1,
    "onBlur": 1,
    "onChange": 1,
    "onInput": 1,
    "onSubmit": 1,
    "onClick": 1,
    "onContextMenu": 1,
    "onDoubleClick": 1,
    "onDrag": 1,
    "onDragEnd": 1,
    "onDragEnter": 1,
    "onDragExit": 1,
    "onDragLeave": 1,
    "onDragOver": 1,
    "onDragStart": 1,
    "onDrop": 1,
    "onMouseDown": 1,
    "onMouseEnter": 1,
    "onMouseLeave": 1,
    "onMouseMove": 1,
    "onMouseOut": 1,
    "onMouseOver": 1,
    "onMouseUp": 1,
    "onSelect": 1,
    "onTouchCancel": 1,
    "onTouchEnd": 1,
    "onTouchMove": 1,
    "onTouchStart": 1,
    "onAnimationStart": 1,
    "onAnimationEnd": 1,
    "onAnimationIteration": 1,
    "onTransitionEnd": 1
};
/**
 * Checking for aria-* and data-* props
 */ var $6107163ca676c195$var$propRe = /^((data|aria)-.*)$/;
function $6107163ca676c195$var$filterReactDomProps(props) {
    var filterProps = {};
    for(var prop in props)if (props.hasOwnProperty(prop) && ($6107163ca676c195$var$DOMProps[prop] || $6107163ca676c195$var$propRe.test(prop))) filterProps[prop] = props[prop];
    return filterProps;
}

});

parcelRegister("h4kRK", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c6d2fef266762864$var$ReactIs, $c6d2fef266762864$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("epw9y"))();

});
parcelRegister("epw9y", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $4YGis = parcelRequire("4YGis");
function $a7dc577091f12bb6$var$emptyFunction() {}
function $a7dc577091f12bb6$var$emptyFunctionWithReset() {}
$a7dc577091f12bb6$var$emptyFunctionWithReset.resetWarningCache = $a7dc577091f12bb6$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $4YGis) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $a7dc577091f12bb6$var$emptyFunctionWithReset,
        resetWarningCache: $a7dc577091f12bb6$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("4YGis", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $39fd934819d484a5$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $39fd934819d484a5$var$ReactPropTypesSecret;

});






//# sourceMappingURL=Heading.15ec3824.js.map
